export default "__VITE_ASSET__607750bd__"